export function readStoredCompanyProfile() {
  try {
    return JSON.parse(localStorage.getItem('companyProfile') || '{}');
  } catch {
    return {};
  }
}

export function isAccountingEnabled(profile = readStoredCompanyProfile()) {
  if (!profile || typeof profile !== 'object') return false;
  const value = profile.IsAccounting;
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }
  return false;
}

export function writeStoredCompanyProfile(profile) {
  if (!profile || typeof profile !== 'object') return;
  localStorage.setItem('companyProfile', JSON.stringify(profile));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('ainsoft:company-profile-updated', {
        detail: profile,
      })
    );
  }
}
